import moment from "moment";
import { formatMoney } from "./invoiceDisplay";

export { formatMoney };

export function isPresentField(value: unknown): boolean {
  return value !== false && value !== null && value !== undefined && value !== "";
}

export function displayField(value: unknown): string {
  if (!isPresentField(value)) return "—";
  return String(value);
}

export function formatOrderDateTime(
  date: string | undefined,
  language: string
): string {
  if (!date) return "—";
  const parsed = moment(date);
  if (!parsed.isValid()) return String(date);

  const isAr = language.startsWith("ar");
  let formatted = parsed
    .locale(isAr ? "ar" : "en")
    .format(
      isAr ? "YYYY/MM/DD , h:mm a" : "DD/MM/YYYY [at] h:mm a"
    );

  if (isAr) {
    formatted = formatted.replace(
      /\d/g,
      (d) => "0123456789"[parseInt(d, 10)]
    );
  }
  return formatted;
}

export function orderStateLabel(
  state: string | undefined,
  t: (key: string) => string
): string {
  if (!state) return "—";
  switch (state) {
    case "done":
      return t("profile.order.serviceDone");
    case "new":
      return t("profile.order.statusNew");
    default:
      return state;
  }
}

export function paymentMethodLabel(
  methodId: string | undefined,
  t: (key: string) => string
): string {
  if (!methodId) return "—";
  if (methodId.toLowerCase() === "hyper pay") {
    return t("Orderslist.payWithCard");
  }
  const key = `Orderslist.${methodId}`;
  const translated = t(key);
  return translated === key ? methodId : translated;
}
